import { render, staticRenderFns } from "./QuizDiabetesManagmentLast.vue?vue&type=template&id=0d13ca3b"
import script from "./QuizDiabetesManagmentLast.vue?vue&type=script&lang=js"
export * from "./QuizDiabetesManagmentLast.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports